import React, { useEffect } from "react";

const FileViewer = ({ isOpen, toggle, fileUrl, fileName, fileType }) => {
  // Si el componente se "abre", abrir el archivo en una nueva pestaña
  useEffect(() => {
    if (isOpen && fileUrl) {
      // Verificar si la URL es de DigitalOcean Spaces y no es una URL prefirmada
      const isDigitalOceanUrl = fileUrl && 
        fileUrl.includes("digitaloceanspaces.com") && 
        !fileUrl.includes("X-Amz-Signature");
      
      if (isDigitalOceanUrl) {
        // Obtener URL prefirmada para archivos de DigitalOcean Spaces
        getPrefirmedUrl(fileUrl)
          .then(prefirmedUrl => {
            window.open(prefirmedUrl, '_blank');
            // Cerrar el "modal" (aunque ya no existe)
            if (toggle) toggle();
          })
          .catch(error => {
            console.error("Error al obtener URL prefirmada:", error);
            // Si hay error, abrir la URL original
            window.open(fileUrl, '_blank');
            if (toggle) toggle();
          });
      } else {
        // Para otras URLs, abrir directamente
        window.open(fileUrl, '_blank');
        // Cerrar el "modal" (aunque ya no existe)
        if (toggle) toggle();
      }
    }
  }, [isOpen, fileUrl, toggle]);

  // Función para obtener URL prefirmada
  const getPrefirmedUrl = async (url) => {
    try {
      const response = await fetch(`/solicitud/archivos/url-prefirmada?url=${encodeURIComponent(url)}&expiracion=3600`);
      if (!response.ok) {
        throw new Error(`Error al obtener URL prefirmada: ${response.status}`);
      }
      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error("Error al obtener URL prefirmada:", error);
      throw error;
    }
  };

  // No renderizamos nada, ya que todo se maneja en el useEffect
  return null;
};

export default FileViewer;
